import { useI18n } from '../i18n/I18nProvider';

/**
 * Selettore di lingua.
 *
 * Costruito dall'elenco delle lingue disponibili, non da una coppia fissa
 * IT/EN: aggiungere una lingua al registro dei cataloghi la fa comparire qui
 * senza modifiche (§21).
 */
export function LanguageSwitcher() {
  const { language, available, setLanguage, t } = useI18n();

  if (available.length < 2) return null;

  return (
    <label className="acs-field" style={{ margin: 0 }}>
      <span className="acs-visually-hidden">{t.common.language}</span>
      <select
        className="acs-input"
        value={language}
        onChange={(event) => setLanguage(event.target.value)}
        style={{ minWidth: '5rem' }}
      >
        {available.map((code) => (
          <option key={code} value={code}>
            {code.toUpperCase()}
          </option>
        ))}
      </select>
    </label>
  );
}
